var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00a0df;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "back"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.19,253.09,252,450.58c19.58,16.05,49,2.12,49-23.2V32.4C301,7.07,271.6-6.86,252,9.2L11.19,206.69A30,30,0,0,0,11.19,253.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M301,104c41.18,16.81,89.2,42.86,135,84C598.55,334,600.7,551.06,600,600c-37.77-65.29-110.55-165.74-236-224a478.25,478.25,0,0,0-63-24Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.434d101ad6f21e8ad0eea02cb9042922.svg";
export { ForwardRef as ReactComponent };